import axios from 'axios'
export default axios.create({
  baseURL: '/api',
  headers: {
    accept: 'application/json',
  },
  data: {},
  // allow 400 status codes to be handled nicely
  validateStatus: (status) => {
    return status >= 200 && status <= 400
  },
  // default value for xsrfCookieName and xsrfHeaderName matches
  // with config in Django base.py
})
